import {
  UserBasicDetails,
  UserBasicInsights,
} from "@shared/lib/types/socialMediaInfluencerV2";
import { Card, Row, Col, Typography, Avatar, Space } from "antd";
import { InstagramOutlined } from "@ant-design/icons";
import styles from "./styles.module.scss";
import { StatCard } from "./StatCard";
import { formatData } from "@shared/lib/utils/formatData";
import { getPlatformIcon } from "@shared/lib/utils/getPlatformIcon";

const { Title, Text, Paragraph } = Typography;

interface Props {
  basicData?: UserBasicDetails;
  basicInsights?: UserBasicInsights;
  platform: string;
}

export function BasicData({ basicData, basicInsights, platform }: Props) {
  return (
    <Card className={styles.card} bodyStyle={{ padding: 20 }}>
      <div className={styles.cardBody}>
        <Row gutter={[24, 24]}>
          {/* Profile Section */}
          <Col xs={24} md={12} className={styles.profileSection}>
            <Avatar
              size={80}
              src={basicData?.profilePicUrl}
              className={styles.avatar}
            />
            <div className={styles.profileInfo}>
              <Title level={4} className={styles.name}>
                {basicData?.name}
              </Title>
              <a
                href={basicData?.link}
                target="_blank"
                rel="noopener noreferrer"
                className={styles.username}
              >
                <Space size={2}>
                  {getPlatformIcon(platform)}
                  {`@${basicData?.username}`}
                </Space>
              </a>
            </div>
          </Col>
          {/* Bio Section */}
          <Col xs={24} md={12} className={styles.bioSection}>
            <Text strong>Bio:</Text>
            <Paragraph className={styles.bioText}>{basicData?.bio}</Paragraph>
            {/* Optionally render email and phone if present */}
            {(basicData?.emailId || []).length > 0 && (
              <Paragraph className={styles.contact}>
                {basicData?.emailId.map((email) => (
                  <span key={email}>
                    {email}
                    <br />
                  </span>
                ))}
              </Paragraph>
            )}
            {(basicData?.phoneNumber || []).length > 0 && (
              <Paragraph className={styles.contact}>
                {basicData?.phoneNumber.map((phone) => (
                  <span key={phone.countryCode}>
                    {phone.countryCode} {phone.phoneNumber}
                    <br />
                  </span>
                ))}
              </Paragraph>
            )}
          </Col>
        </Row>
        {basicInsights?.status === "Completed" && (
          <Row gutter={[20, 20]} className={styles.statsRow}>
            {/* Followers */}
            <Col xs={24} md={6}>
              <StatCard
                title="Followers"
                value={formatData(basicData?.followers || 0, "a")}
                tip={basicInsights?.followerCount?.tip}
                description="Real followers are calculated by the system"
              />
            </Col>
            {/* Sponsored Performance */}
            <Col xs={24} md={6}>
              <StatCard
                title="Sponsored Performance"
                value={formatData(
                  basicInsights?.sponsoredPerformance?.value || 0,
                  "a"
                )}
                tip={basicInsights?.sponsoredPerformance?.tip}
                // description="The total Price on influencers calculated by prices entered"
              />
            </Col>
            {/* Promotion Frequency */}
            <Col xs={24} md={6}>
              <StatCard
                title="Promotion Frequency"
                value={formatData(
                  basicInsights?.promotionalFrequency?.value || 0,
                  "a"
                )}
                tip={basicInsights?.promotionalFrequency?.tip}
                // description="The total Price on influencers calculated by prices entered"
              />
            </Col>
            <Col xs={24} md={6}>
              {platform === "instagram" ? (
                <>
                  {/* Avg Reel Views (Sponsored) */}

                  <StatCard
                    title="Avg Reel Views (Sponsored)"
                    value={formatData(
                      basicInsights?.avgReelViews?.value || 0,
                      "a"
                    )}
                    tip={basicInsights?.avgReelViews?.tip}
                    // description="The total Price on influencers calculated by prices entered"
                  />
                </>
              ) : (
                <>
                  <StatCard
                    title="Avg Views"
                    value={formatData(basicInsights?.avgViews?.value || 0, "a")}
                    tip={basicInsights?.avgViews?.tip}
                    // description="The total Price on influencers calculated by prices entered"
                  />
                </>
              )}
            </Col>
          </Row>
        )}
      </div>
    </Card>
  );
}
